"use client";

import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Heading, useThemeSlot } from "@huub-web/ui";
import { Illustration } from "@huub-web/shared";

const DefaultHubHeading: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Illustration
        name="default"
        alt={t("hubHeading.alt")}
        alignSelf="center"
        size="s"
      />
      <Heading
        variant="main"
        title={t("hubHeading.title")}
        description={t("hubHeading.description")}
      />
    </>
  );
};

export type HubHeadingTemplateProps = Record<string, never>;

export const HubHeadingTemplate: FC<HubHeadingTemplateProps> = ({ ref }) => {
  const HubHeading = useThemeSlot({
    key: "hubHeading",
    defaultComponent: DefaultHubHeading,
  });

  return (
    <Flex ref={ref} direction="column" gap="s">
      <HubHeading />
    </Flex>
  );
};
